import * as angular from "angular";
import { Group } from "../models/group.model";

export class GroupService {
    private apiRoot: string;
    private v2Root: string;
    private $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = __env.apiUrl() + "/group";
        this.v2Root = "/v2/group";
    }

    all(data: { effort: object | null }): Promise<object> {
        return this.$http.get(this.apiRoot, data);
    }

    info(gid: string): Promise<object> {
        return this.$http.get(this.apiRoot + "/" + gid);
    }

    update(group: Group): Promise<object> {
        return this.$http.post(this.v2Root + "/" + group.gid, group);
    }

    create(group: Group): Promise<object> {
        return this.$http.post(this.v2Root, group);
    }

    segment(group: Group): Promise<object> {
        return this.$http.post(this.v2Root + "/segment", group);
    }

    addMembers(gid: string, data: object): Promise<object> {
        return this.$http.post(this.apiRoot + "/addMembers/" + gid, data);
    }

    removeMembers(gid: string, data: object): Promise<object> {
        return this.$http.post(this.apiRoot + "/removeMembers/" + gid, data);
    }

    getCount(data: object): Promise<object> {
        return this.$http.post(this.apiRoot + "/getCount", data);
    }

    bulk_delete(data: object): Promise<object> {
        return this.$http.post(this.apiRoot + "/bulk_delete", data);
    }
    bulk_update(data: object): Promise<object> {
        return this.$http.post(this.apiRoot + "/bulk_update", data);
    }

    refreshList(group: Group): Promise<object> {
        return this.$http.post(
            this.v2Root + "/refresh_dynamic_list/" + group.gid,
            group
        );
    }

    bulkRefreshList(data: object): Promise<object> {
        return this.$http.post(
            this.v2Root + "/bulk_refresh_dynamic_list",
            data
        );
    }

    remove(gid: string): Promise<object> {
        return this.$http.delete(this.apiRoot + "/" + gid);
    }
    removeAssignment(id: string): Promise<object> {
        return this.$http.delete(this.apiRoot + "/assignment/" + id);
    }
    bulk_assignment(data: object) {
        return this.$http.post(this.apiRoot + "/bulk_assignment", data);
    }
}

angular.module("vcServices").service("GroupService", GroupService);
